const alertTypes = {
  VaccinationEligible: 45,
};

export default alertTypes;
